module.exports = __webpack_public_path__ + "static/kristin-e60bd4721e67c3b533c30beaeb8a55ab.jpg";